import SmartBanner from 'shared/lib/smartbanner/smartbanner.js'

let smartbanner

window.addEventListener('load', function () {
  smartbanner = new SmartBanner()
  smartbanner.publish()
})
